import { render, staticRenderFns } from "./AddInterview.vue?vue&type=template&id=89cc1372&scoped=true"
import script from "./AddInterview.vue?vue&type=script&lang=js"
export * from "./AddInterview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cc1372",
  null
  
)

export default component.exports